import { days, shiftColors, getWeekNumber,dayStatuses } from "../../core/utils/weekPlanUtils";
export const mapWorkDurationToShift = (workDuration) => {
    const startHour = new Date(workDuration.startTime).getHours();

    // Night shift: starts at 18:00 or later
    if (startHour >= 18) return "night";
    // Afternoon shift: starts at 13:00 or later (but before 18:00)
    if (startHour >= 13) return "late";
    // Forenoon shift: starts before 13:00
    return "early";
  };

export const transformBackendData = (backendData) => {
  return backendData.filter(emp=>emp.calendarEmployees?.[0]?.activate).map((emp) => {
    const schedule = {};
    days.forEach((day) => (schedule[day] = []));

    const calendar = emp.calendarEmployees?.[0];
    
    calendar?.dailyPlanEmployees?.forEach((daily) => {
      const dayName = daily.day;
      const status = dayStatuses[daily.dayStatus];
      schedule[dayName] = {
      status,
      shifts:(daily.workDurationEmployees || []).map((w) => {
       
        const start = new Date(w.startTime);
        const end = new Date(w.endTime);
        const type = mapWorkDurationToShift(w);
        const time = `${start.getHours().toString().padStart(2, "0")}:${start
          .getMinutes()
          .toString()
          .padStart(2, "0")}-${end.getHours().toString().padStart(2, "0")}:${end
          .getMinutes()
          .toString()
          .padStart(2, "0")}`;
        return { time, type };
      }),
    };
    });

    return {
      name: emp.userName,
      userId: emp.userId,
      email: emp.email,
      schedule,
    };
  });
};